function model(name) {
  return {
    /* GET */
    LOAD: `${name}/LOAD`,
    LOAD_SUCCESS: `${name}/LOAD_SUCCESS`,
    LOAD_FAIL: `${name}/LOAD_FAIL`,

    /* GET */
    LOAD_SINGLE: `${name}/LOAD_SINGLE`,
    LOAD_SINGLE_SUCCESS: `${name}/LOAD_SINGLE_SUCCESS`,
    LOAD_SINGLE_FAIL: `${name}/LOAD_SINGLE_FAIL`,

    /* POST */
    CREATE: `${name}/CREATE`,
    CREATE_SUCCESS: `${name}/CREATE_SUCCESS`,
    CREATE_FAIL: `${name}/CREATE_FAIL`,

    /* PUT */
    EDIT: `${name}/EDIT`,
    EDIT_SUCCESS: `${name}/EDIT_SUCCESS`,
    EDIT_FAIL: `${name}/EDIT_FAIL`,

    /* DELETE */
    DELETE: `${name}/DELETE`,
    DELETE_SUCCESS: `${name}/DELETE_SUCCESS`,
    DELETE_FAIL: `${name}/DELETE_FAIL`,

    /* OPTIONS */
    SORT: `${name}/SORT`,
    SEARCH: `${name}/SEARCH`
  };
}

const actions = {
  LOGIN: 'LOGIN',
  LOGIN_SUCCESS: 'LOGIN_SUCESS',
  LOGIN_FAIL: 'LOGIN_FAIL',

  LOGIN_WITH_FACEBOOK: 'LOGIN_WITH_FACEBOOK',
  LOGIN_WITH_FACEBOOK_SUCCESS: 'LOGIN_WITH_FACEBOOK_SUCCESS',
  LOGIN_WITH_FACEBOOK_FAIL: 'LOGIN_WITH_FACEBOOK_FAIL',
  LOGIN_WITH_FACEBOOK_NO_ACCOUNT: 'LOGIN_WITH_FACEBOOK_NO_ACCOUNT',

  LOGOUT: 'LOGOUT',
  LOGOUT_SUCCESS: 'LOGOUT_SUCCESS',
  LOGOUT_FAIL: 'LOGOUT_FAIL',

  TOKEN_REFRESH: 'TOKEN_REFRESH',
  TOKEN_REFRESH_SUCCESS: 'TOKEN_REFRESH_SUCCESS',
  TOKEN_REFRESH_FAIL: 'TOKEN_REFRESH_FAIL',

  LOAD_USER_ME: 'LOAD_USER_ME',
  LOAD_USER_ME_SUCCESS: 'LOAD_USER_ME_SUCCESS',
  LOAD_USER_ME_FAIL: 'LOAD_USER_ME_FAIL',

  /* Users */
  USERS: model('USERS'),

  /* Awards */
  AWARDS: model('AWARDS'),

  /* Info */
  INFO: model('INFO'),

  /* Categories */
  CATEGORIES: model('CATEGORIES'),

  /* Works */
  WORKS: model('WORKS'),

  /* Instagram */
  INSTAGRAM: model('INSTAGRAM')
};

export default actions;



// WEBPACK FOOTER //
// ./src/constants/actions.js